export default {
    oldReceptionsConsulates: state => {
        return state.oldReceptionsConsulates;
    },
    oldReceptionsReferrals: state => {
        return state.oldReceptionsReferrals;
    },
    receptions: state => {
        return state.receptions;
    },
    nowTime: state => {
        return state.nowTime;
    },
    receptionTypes: state => {
        return state.receptionTypes;
    },
    receptionToManage: state => {
        return state.receptionToManage;
    },
    userToManage: state => {
        return state.userToManage;
    },
    receptionsToCreate: state => {
        return state.receptionsToCreate;
    },
    reception: state => {
        return state.reception;
    },
    discountsList: state => {
        return state.discountsList;
    },
    usersList: state => {
        return state.usersList;
    },
    receptionServices: state => {
        return state.receptionServices;
    },
    doneReceptions: state => {
        return state.doneReceptions;
    },
    noCharge: state => {
        return state.noCharge;
    },
    repeat: state => {
        return state.repeat;
    },
    description: state => {
        return state.description;
    },
    receptionToPayForServices: state => {
        return state.receptionToPayForServices;
    },
    receptionToPayFor: state => {
        return state.receptionToPayFor;
    },
    patientPayment: state => {
        return state.patientPayment;
    },
    excessPayment: state => {
        return state.excessPayment;
    },
    currentExcessPayment: state => {
        return state.currentExcessPayment;
    },
    serviceReturn: state => {
        return state.serviceReturn;
    },
    allPayments: state => {
        return state.allPayments;
    },
    receptionServicesRows: state => {
        return state.receptionServicesRows;
    },
    visitServices: state => {
        return state.visitServices;
    },
    // createdReceptionIdForAddVisit: state => {
    //     return state.createdReceptionIdForAddVisit;
    // },
    createdVisitService:state=>{
        return state.createdVisitService;
    },
    createdReception:state=>{
        return state.createdReception;
    },
    usersForVisit: state=>{
        return state.usersForVisit;
    },
    discountsForVisit: state=>{
        return state.discountsForVisit;
    },
    addedVisitService: state=>{
        return state.addedVisitService;
    },
    currentServiceReturns: state=>{
        return state.currentServiceReturns;
    },
    doneReceptionsForThisRoom: state=>{
        return state.doneReceptionsForThisRoom;
    },
    doctors: state=>{
        return state.doctors;
    },

    callingDoctors: state=>{
        return state.callingDoctors;
    },

    insurances: state => {
        return state.insurances;
    },
    currentDayReceptions: state => {
        return state.currentDayReceptions;
    },
    currentDayReceptionSearch: state => {
        return state.currentDayReceptionSearch;
    },
    total: state => {
        return state.total;
    },
    paymentToEdit: state => {
        return state.paymentToEdit;
    },
}
